import About from '@/components/pages/artist/About'
import Onboarding from '@/components/pages/artist/Onboarding'
import Activity from '@/components/pages/artist/Activity'
import EditLiveStream from '@/components/pages/artist/EditLiveStream'
import Dashboard from '@/components/pages/artist/Dashboard'
import EditAlbum from '@/components/pages/artist/EditAlbum'
import EditProfile from '@/components/pages/artist/EditProfile'
import PayoutMethod from '@/components/pages/artist/PayoutMethod'
import AlbumList from '@/components/pages/artist/AlbumList'
import ManageLiveStream from '@/components/pages/artist/ManageLiveStream'
import LiveStreamList from '@/components/pages/artist/LiveStreamList'
import LiveStreamDetail from '@/components/pages/artist/LiveStreamDetail'
import SendMessage from '@/components/pages/artist/SendMessage'
import VideoDetail from '@/components/pages/artist/VideoDetail'
import EditVideo from '@/components/pages/artist/EditVideo'
import VideoList from '@/components/pages/artist/VideoList'
import ArtistMessages from '@/components/pages/artist/Messages'
import Followers from '@/components/pages/artist/Followers'
import ManageComments from '@/components/pages/artist/ManageComments'
import FeaturedVideos from '@/components/pages/artist/FeaturedVideos'
import BlockedUsers from '@/components/pages/fan/BlockedUsers'
import ReportArtist from '@/components/pages/artist/ReportArtist'

const reqArtist = { requireUserType: 'artist' }
const reqLogin = { requireLogin: true }

export default [
  { path: '/artist/new/', name: 'artist-onboarding', component: Onboarding, meta: { fullScreen: true, requireLogin: true } },
  { path: '/artist/about/edit/', name: 'artist-profile-edit', component: EditProfile, meta: reqArtist },
  { path: '/artist/about/payout/', name: 'artist-payout-method', component: PayoutMethod, meta: reqArtist },
  { path: '/artist/messages/', name: 'artist-messages', component: ArtistMessages, meta: reqArtist },
  { path: '/artist/activity/', name: 'artist-my-activity', component: Activity, meta: reqArtist },
  { path: '/artist/followers/', name: 'artist-followers', component: Followers, meta: reqArtist },
  { path: '/artist/blocked/', name: 'artist-blocked-users', component: BlockedUsers, meta: reqArtist },
  { path: '/artist/dashboard/', name: 'artist-dashboard', component: Dashboard, meta: reqArtist },

  { path: '/artist/live/create/', name: 'artist-live-stream-create', component: EditLiveStream, meta: reqArtist },
  { path: '/artist/live/:visibility/', name: 'artist-my-live-stream-list', component: LiveStreamList, meta: reqArtist },
  { path: '/artist/live/:id/edit/', name: 'artist-live-stream-edit', component: EditLiveStream, meta: reqArtist },
  { path: '/artist/live/:id/comments/', name: 'artist-live-stream-manage-comments', component: ManageComments, meta: { requireUserType: 'artist', contentType: 'live' } },
  { path: '/artist/live/:id/preview/', name: 'artist-live-stream', component: ManageLiveStream, meta: reqArtist },

  { path: '/artist/albums/create/', name: 'artist-album-create', component: EditAlbum, meta: reqArtist },
  { path: '/artist/albums/:id/edit/', name: 'artist-album-edit', component: EditAlbum, meta: reqArtist },
  { path: '/artist/albums/:visibility/', name: 'artist-album-list', component: AlbumList, meta: reqArtist },

  { path: '/artist/videos/:visibility/', name: 'artist-video-list', component: VideoList, meta: reqArtist },
  { path: '/artist/videos/create/', name: 'artist-video-create', component: EditVideo, meta: reqArtist },
  { path: '/artist/videos/:id/edit/', name: 'artist-video-edit', component: EditVideo, meta: reqArtist },
  { path: '/artist/videos/:id/comments/', name: 'artist-video-manage-comments', component: ManageComments, meta: { requireUserType: 'artist', contentType: 'video' } },
  { path: '/artist/videos/:id/detail/', name: 'artist-video-detail', component: VideoDetail },

  { path: '/artist/:artistId/about/', name: 'artist-about', component: About },
  { path: '/artist/:artistId/activity/', name: 'artist-activity', component: Activity, meta: reqLogin },
  { path: '/artist/:artistId/message/', name: 'artist-send-message', component: SendMessage, meta: reqLogin },
  { path: '/artist/:artistId/featured/', name: 'artist-featured', component: FeaturedVideos },
  { path: '/artist/:artistId/report/', name: 'artist-report', component: ReportArtist },

  { path: '/artist/:artistId/videos/', name: 'artist-videos', component: VideoList },
  { path: '/artist/:artistId/live/', name: 'artist-live-stream-list', component: LiveStreamList },
  { path: '/artist/:artistId/live/:liveId/', name: 'artist-live-stream-detail', component: LiveStreamDetail },
  { path: '/artist/:artistId/albums/', name: 'artist-albums', component: AlbumList }
]



// WEBPACK FOOTER //
// ./src/router/artist.js